var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/Divider.style.ts
import styled from "@emotion/styled";
function getDividerStyle(size, color, orientation, isFlexItem) {
  return {
    horizontal: {
      width: "100%",
      borderTop: `${size}px solid ${color}`
    },
    vertical: {
      height: isFlexItem ? "auto" : "100%",
      borderLeft: `${size}px solid ${color}`,
      alignSelf: isFlexItem ? "stretch" : "auto"
    }
  }[orientation];
}
var StyledDivider = styled.hr`
  border: none;
  margin: 0;

  ${({ size, color, orientation, isFlexItem }) => getDividerStyle(size, color, orientation, isFlexItem)}
`;

export {
  __spreadValues,
  __objRest,
  StyledDivider
};
